import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["textarea", "input", "button"];
  static values  = { url: String };

  triggerUpload() {
    this.inputTarget.click();
  }

  fileSelected(event) {
    const file = event.target.files[0];
    if (file) this.#upload(file);
    event.target.value = "";
  }

  dragOver(event) {
    event.preventDefault();
  }

  drop(event) {
    event.preventDefault();
    const file = [...event.dataTransfer.items]
      .find(item => item.kind === "file" && item.type.startsWith("image/"))
      ?.getAsFile();
    if (file) this.#upload(file);
  }

  async #upload(file) {
    const btn = this.buttonTarget;
    const originalHTML = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '<span class="spinner-border spinner-border-sm" role="status"></span>';

    const body = new FormData();
    body.append("image", file);

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: { "X-CSRF-Token": csrfToken },
        body
      });
      if (!response.ok) throw new Error();
      const { url } = await response.json();
      this.#insertAtCursor(`![](${url})`);
    } catch {
      alert("Image upload failed. Please try again.");
    } finally {
      btn.disabled = false;
      btn.innerHTML = originalHTML;
    }
  }

  #insertAtCursor(text) {
    const ta = this.textareaTarget;
    const { selectionStart: start, selectionEnd: end } = ta;
    ta.value = ta.value.slice(0, start) + text + ta.value.slice(end);
    ta.selectionStart = ta.selectionEnd = start + text.length;
    ta.dispatchEvent(new Event("input"));
    ta.focus();
  }
}
